import './BooleanIcon.scss'
import { MdOutlineCheck, MdOutlineClose } from 'react-icons/md'
import { clx } from '../clx'
import { VisuallyHidden } from '../VisuallyHidden'

export interface BooleanIconProps {
  /** `true` or `'true'` is on; anything else is off. */
  value: unknown
  className?: string
}

/** react-admin's BooleanField: a check or a cross, with "Yes"/"No" for assistive tech. */
export function BooleanIcon({ value, className }: BooleanIconProps) {
  const on = value === true || value === 'true'
  return (
    <span
      className={clx(
        'boolean-icon',
        on ? 'boolean-icon--is-on' : 'boolean-icon--is-off',
        className
      )}
    >
      {on ? <MdOutlineCheck aria-hidden="true" /> : <MdOutlineClose aria-hidden="true" />}
      <VisuallyHidden>{on ? 'Yes' : 'No'}</VisuallyHidden>
    </span>
  )
}
